import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DeleteCardContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DeleteCardProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete("billings/cards", { data: payload });
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <DeleteCardContext.Provider value={contextValue}>
      {children}
    </DeleteCardContext.Provider>
  );
};

export default DeleteCardProvider;
